import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Section, ResponsiveContainer } from '@lib/common';

export const AboutPage: React.FC = () => {
  const { t } = useTranslation();

  const sectionProps = {
    title: t('about.title'),
  };

  const content: string[] = t('about.main', { returnObjects: true });

  return (
    <ResponsiveContainer>
      <Section {...sectionProps}>
        {content.map((text, i) => (
          <Box key={i} mb={3}>
            <Typography component="p">{text}</Typography>
          </Box>
        ))}
      </Section>
    </ResponsiveContainer>
  );
};
